import { render } from "./Deduction.vue?vue&type=template&id=5b90cbb6"
import script from "./Deduction.vue?vue&type=script&lang=js"
export * from "./Deduction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__